import { createStore, applyMiddleware } from 'redux';
import rootReducer from './reducers';
import middlewares from './middlewares';

const store = createStore(rootReducer, applyMiddleware(...middlewares));

if (import.meta.hot) {
  import.meta.hot.accept('./reducers', (newModule) => {
    if (newModule) {
      store.replaceReducer(newModule.default);
    }
  });
}

export default store;
